// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"_4-z","colorTextValue":"a5-z","swatches":"b5-z","collapseLink":"c5-z","isCollapsed":"d5-z","dropdown":"e5-z","disabled":"f5-z"};